import Spinner from "../Spinner";
import Button from "../Button";

type AppLoaderProps = {
  text?: string;
  onClose?: () => void;
};

export default function AppLoader({ text, onClose }: AppLoaderProps) {
  return (
    <div className="app__loader">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "var(--g-16)",
        }}
      >
        <Spinner />
        {text && (
          <p
            style={{
              color: "#fff",
              fontSize: "var(--font-md)",
              fontWeight: "var(--medium)",
            }}
          >
            {text}
          </p>
        )}
        {onClose && (
          <Button buttonType="primary" type="button" onClick={onClose}>
            Close Loader
          </Button>
        )}
      </div>
    </div>
  );
}
